import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class FarmerRequest {
    brokerId: number;
    constructor(brokerId:number){
        this.brokerId = brokerId;
    }
}